<div class="all-content">
    <div class="top">
        {{ getLanguages('workflow/top/title') }}
    </div>
    <div class="row">
        <div class="div-search" [ngClass]="isSearch ? 'div-search-fixed' : ''">
            <div class="search">
                <input type="text" [(ngModel)]="text" (keyup.enter)="searchNodes()">
                <i class="fas fa-xmark cancel-search" *ngIf="isSearch" (click)="clearFilter()"></i>
            </div>
            <button (click)="searchNodes()">
                {{ getLanguages('search') }}
            </button>

            <div class="filter-section count-proccess" *ngIf="isSearch">
                <div class="filter" *ngIf="filterArray?.length > 0">
                    {{ filterCursor }}
                    {{ getLanguages('businessSolution/search/of') }}
                    {{ filterArray?.length }}
                    <button class="button-navigation" (click)="previous()"
                        [class.disabled-button-filter]="filterCursor === 1" [disabled]="filterCursor === 1"> <i
                            class="fas fa-chevron-left"></i> </button>
                    <button class="button-navigation" (click)="next()"
                        [class.disabled-button-filter]="filterCursor === filterArray.length"
                        [disabled]="filterCursor === filterArray.length"> <i class="fas fa-chevron-right"></i> </button>
                </div>
                <span *ngIf="filterArray?.length == 0">
                    {{ getLanguages('businessSolution/search/noResult') }}
                </span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="div-buttons">
            <button (click)="toggleUploadChooseReference()" class="button-tooltip left-button" [disabled]="isEdited" matTooltip="{{ getLanguages('personas/choose_reference/label') }}" [ngClass]="isEdited ? 'disabled no-pointer' : ''" *ngIf="getSystemPermission('workflow', 'choose_reference_personas')">
                {{ getLanguages('personas/choose_reference') }}
            </button>
            <div class="button-save">
                <button (click)="saveTree(null, workflow?.uuid)" [disabled]="!isEdited"
                    class="left-button button-tooltip" [ngClass]="!isEdited ? 'disabled no-pointer' : ''"
                    *ngIf="getSystemPermission('workflow', 'save_tree') && isEdited">
                    {{ getLanguages('saveChangesTree') }}
                </button>
            </div>
            <button (click)="toggleUpload()" class="button-tooltip left-button"
                *ngIf="getSystemPermission('workflow', 'import')">
                {{ getLanguages('businessSolution/top/info/import') }}
            </button>
            <div class="button-save" *ngIf="getSystemPermission('workflow', 'export')">
                <button class="save" [matMenuTriggerFor]="selectExport">
                    {{ getLanguages('businessSolution/top/info/export') }}
                    <i class="fas fa-angle-down" style="margin-left: 2vh;"></i>
                </button>
                <mat-menu #selectExport="matMenu">
                    <button (click)="getTreeXls('json')" class="menu-button">
                        {{ getLanguages('businessSolution/top/info/export/json') }}
                    </button>
                    <button (click)="getTreeXls('xls')" class="menu-button">
                        {{ getLanguages('businessSolution/top/info/export/xls') }}
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="isEdited">
        <div class="alert-save">
            <div class="toggle-save"></div>
            {{ getLanguages('auth/alert/isEdited') }}
        </div>
    </div>

    <div class="content">
        <div class="title">
            <span>
                {{ getLanguages('workflow/content/workflowTree') }}
            </span>
            <i class="fas fa-plus" (click)="showModalCreate()" *ngIf="getSystemPermission('workflow', 'create')"></i>
        </div>
        <div class="content-content">
            <div class="tree" [ngStyle]="{'width': '50%'}">
                <div class="noData" *ngIf="noData && !isLoading">
                    <div class="icon">
                        <i class="fa-solid fa-exclamation"></i>
                    </div>
                    <span>
                        {{ getLanguages('errors/noData')}}
                    </span>
                </div>

                <p-tree class="ptree" [value]="files" *ngIf="!isLoading && !noData"
                    (onNodeExpand)="onNodeExpand($event)" [expandedKeys]="expandedKeys">
                    <ng-template let-node pTemplate="default">
                        <div class="pcontent" id="{{ node.uuid }}">
                            <div class="ptitle">
                                <i class="fa-solid fa-user-tie"></i>
                                <i class="fa-solid fa-ban" *ngIf="node?.is_available == false"></i> 
                                <section>                                        
                                    <div [class.error_node]="hasError(node.uuid)" class="button-tooltip">
                                        <span class="ptitle-content-text"
                                            [ngClass]="{
                                                'error-name': node?.error,
                                                'title-destak': filterArray.includes(node.uuid)
                                            }">
                                            {{ (node?.label ?? '') }}
                                            <i *ngIf="node?.error" class="fa-solid fa-triangle-exclamation error-icon"></i>
                                        </span>
                                    </div>
                                </section>
                            </div>

                            <div class="p-icons-new">
                                <button class="button-menu" (click)="eventStopPropagation($event)"
                                    [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpen(node)">
                                    <i class="fa-solid fa-ellipsis"></i>
                                </button>
                            </div>

                            <mat-menu #menu="matMenu" class="custom-menu">
                                <ng-container *ngFor="let item of menuArray">
                                    <ng-container *ngIf="item.condition(selectedNode)">
                                        <button mat-menu-item class="custom-menu-item" (click)="handleMenuItemClick(item, $event)"> 
                                            <i [class]="item.icon"></i>
                                            <span>{{ item.name }}</span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </mat-menu>
                        </div>
                    </ng-template>
                </p-tree>
            </div>
        </div>
    </div>
</div>

<div class="background-modals" *ngIf="isShowCreate || isShowDelete || isShowChooseReference || isShowImport">
    <app-import *ngIf="isShowImport" (toggleImportModal)="toggleUpload()" (updateFiles)="updateFiles($event)" [properties]="properties" [parameters]="parameters" [type]="'workflow'"> </app-import>
    <app-delete-component *ngIf="isShowDelete" (toggleDelete)="isShowDelete = false" (updateFiles)="updateFiles($event)" [parameters]="parameters" [type]="1"></app-delete-component>
    <app-access-user *ngIf="isShowCreate" [parameters]="parameters" [isShowCascade]="false" (toggleModal)="closeShowCreate()" (setArrayAccessUsers)="setArrayAccessUsers($event)"></app-access-user>
    <app-choose-reference-personas *ngIf="isShowChooseReference" [type]="workflow" (toggleModal)="toggleUploadChooseReference($event)" [referenceTreeShared]="referenceTreeShared"></app-choose-reference-personas>
</div>